import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-question-multi',
  templateUrl: './question-multi.component.html',
  styleUrls: ['./question-multi.component.scss']
})
export class QuestionMultiComponent implements OnInit {
  @Input() isEditValue: boolean;
  @Input() form: FormGroup;

  modalData: any;
  multipleChoiceForm: FormGroup;
  rankingForm: FormGroup;
  ratingForm: FormGroup;
  type: string;
  subType: string;
  subQuestionType = [{
    name: 'Multiple Choice'
  }, {
    name: 'Rating'
  }, {
    name: 'Ranking'
  }, {
    name: 'Most/Least'
  }];
  ratingLevel = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  valid: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
  }

  setSubType(t) {
    this.subType = t.target.value;

    this.multiFormArray.clear();
    this.multiFormArray.reset();
  }

  addSubQuestion(form) {
    // console.log(this.subType);

    switch (this.subType) {
      case 'Multiple Choice':
      case 'Most/Least': {
        form.push(this.fb.group({
          question: ['', Validators.required],
          media: [''],
          time_again: [''],
          unlimit: [''],
          choices: this.fb.array([])
        }))
        break;
      }

      case 'Rating': {
        form.push(this.fb.group({
          question: ['', Validators.required],
          level: ['', Validators.required],
          choices: this.fb.array([]),
        }))
        break;
      }

      case 'Ranking': {
        form.push(this.fb.group({
          question: ['', Validators.required],
          choices: this.fb.array([]),
        }))
        break;
      }
    }
  }

  get multiFormArray(): FormArray {
    return this.form.get('subQuestion') as FormArray;
  }

  // สำหรับ multi ใช้ลบคำถามย่อย
  deleteChoice(form, index) {
    form.removeAt(index);
  }
}
